<h2 mat-dialog-title>Deduplication Preview</h2>
<mat-dialog-content style="padding: 24px;">
  <!-- Summary Section -->
  <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-bottom: 24px;">
    <div style="padding: 16px; background: #f5f5f5; border-radius: 8px; text-align: center;">
      <div style="font-size: 24px; font-weight: bold; color: #667eea;">{{ goldenKey }}</div>
      <div style="font-size: 12px; color: #666; margin-top: 4px;">Survivor Record ID</div>
    </div>
    <div style="padding: 16px; background: #f5f5f5; border-radius: 8px; text-align: center;">
      <div style="font-size: 24px; font-weight: bold; color: #4facfe;">{{ getMergedRecordCount() }}</div>
      <div style="font-size: 12px; color: #666; margin-top: 4px;">Records to Merge</div>
    </div>
    <div style="padding: 16px; background: #f5f5f5; border-radius: 8px; text-align: center;">
      <div style="font-size: 24px; font-weight: bold; color: #ff9800;">{{ getChangedFieldsCount() }}</div>
      <div style="font-size: 12px; color: #666; margin-top: 4px;">Fields Changed</div>
    </div>
  </div>

  <!-- Final Data Table -->
  <div style="margin-bottom: 24px;">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
      <h3 style="margin: 0; font-size: 18px; font-weight: 600;">Final Data Preview</h3>
      <button mat-button 
              [color]="showOnlyChanged ? 'primary' : ''"
              (click)="toggleShowOnlyChanged()"
              style="display: flex; align-items: center; gap: 8px;">
        <i class="material-icons" style="font-size: 18px;">{{ showOnlyChanged ? 'filter_alt' : 'filter_alt_outlined' }}</i>
        <span>{{ showOnlyChanged ? 'Show All Fields' : 'Show Only Changed' }}</span>
      </button>
    </div>
<div style="overflow-x: auto; border: 1px solid #e0e0e0; border-radius: 8px;">
      <table style="width: 100%; border-collapse: collapse; background: white;">
        <thead>
          <tr style="background: #f8f9fa; border-bottom: 2px solid #e0e0e0;">
            <th style="padding: 12px; text-align: left; font-weight: 600; font-size: 14px; color: #333; min-width: 200px;">Field Name</th>
            <th style="padding: 12px; text-align: left; font-weight: 600; font-size: 14px; color: #333; min-width: 250px;">Original Value</th>
            <th style="padding: 12px; text-align: left; font-weight: 600; font-size: 14px; color: #333; min-width: 250px;">Final Value</th>
            <th style="padding: 12px; text-align: center; font-weight: 600; font-size: 14px; color: #333; min-width: 100px;">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let field of getFilteredFields()" 
              [style.background]="hasFieldChanged(field) ? '#fff3e0' : '#ffffff'"
              style="border-bottom: 1px solid #f0f0f0;">
            <td style="padding: 12px; font-weight: 600; color: #333;">
              {{ getHeaderName(field) }}
            </td>
            <td style="padding: 12px; color: #666;">
              <span [style.text-decoration]="hasFieldChanged(field) ? 'line-through' : 'none'"
                    [style.opacity]="hasFieldChanged(field) ? '0.7' : '1'">
                {{ getSurvivorValue(field) || 'N/A' }}
              </span>
            </td>
            <td style="padding: 12px; color: #333; font-weight: 500;">
              <span [style.color]="hasFieldChanged(field) ? '#667eea' : '#333'"
                    [style.font-weight]="hasFieldChanged(field) ? '600' : '500'">
                {{ getFieldValue(field) || 'N/A' }}
              </span>
            </td>
            <td style="padding: 12px; text-align: center;">
              <span *ngIf="hasFieldChanged(field)" 
                    style="display: inline-block; padding: 4px 12px; background: #ffc107; color: #333; border-radius: 12px; font-size: 11px; font-weight: 600;">
                CHANGED
              </span>
              <span *ngIf="!hasFieldChanged(field)" 
                    style="display: inline-block; padding: 4px 12px; background: #e8f5e9; color: #2e7d32; border-radius: 12px; font-size: 11px; font-weight: 600;">
                UNCHANGED
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
<!-- Records to Merge Info -->
  <div *ngIf="merged && merged.length > 0" style="margin-bottom: 24px;">
    <h3 style="margin: 0 0 16px 0; font-size: 18px; font-weight: 600;">Records to be Merged</h3>
    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
      <div *ngFor="let record of merged; let i = index" 
           style="padding: 12px 16px; background: #e3f2fd; border-radius: 8px; border-left: 4px solid #4facfe;">
        <div style="font-size: 12px; color: #666; margin-bottom: 4px;">Record {{ i + 1 }}</div>
        <div style="font-size: 14px; font-weight: 600; color: #1976d2;">ID: {{ record.data?.[idField] || 'N/A' }}</div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding: 20px 24px; justify-content: flex-end; border-top: 1px solid #e0e0e0;">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onConfirm()" cdkFocusInitial>Confirm & Perform Dedup</button>
</mat-dialog-actions>
